<template>
  <div :class="['input-error', 'text8', error && 'visible']">
    <span v-if="error">
      {{ error }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss">
.input-error {
  position: absolute;
  top: 100%;
  padding-left: rem(15px);
  transition: 200ms opacity ease;
  opacity: 0;

  @include setColor(--color-status-error);

  &.visible {
    opacity: 1;
    transition-delay: 0.3s;
  }
}
</style>
